module.exports = __webpack_public_path__ + "static/media/kfc.34bafb9c.svg";